// extracted by mini-css-extract-plugin
module.exports = {"header":"Suggestions_header__Pcy6e","container":"Suggestions_container__3jnI9","suggestion":"Suggestions_suggestion__1jdHA"};